<template>
  <div class="py-6 px-8">
    <h-header :title="title" />
    <AppointmentReports ref="appointmentReportFilters" />
  </div>
</template>

<script>
import AppointmentReports from '@/components/report/AppointmentReports'
export default {
  name: 'AppointmentReport',

  components: { AppointmentReports },

  data() {
    return {
      title: this.$router.currentRoute.name,
    }
  },
}
</script>
